import { guid, Records } from "@buildwithflux/shared";
import { keys, values } from "lodash";
import { handleRemoveSubjectProperties, handleSetSubjectProperties } from "../document-actions";
/**
 * Applies component properties actions by updating or removing properties for components
 * @param action The component properties action to apply
 * @param dependencies The dependencies needed to apply the action
 * @returns A promise that resolves to the result of applying the action
 */
export function applyComponentPropertiesAction(action, document, actionContext) {
    const touchedElementUids = [];
    const elements = document?.elements;
    const propertyRemovalMap = {};
    const propertyUpdateMap = {};
    const componentPropertiesUpdated = [];
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    action.forEach((component) => {
        const element = values(elements || {}).find((element) => element.label?.toLowerCase().trim() === component.componentDesignator.toLowerCase().trim());
        if (element) {
            const componentProperties = element?.properties;
            const componentPropertyUidsToRemove = component.componentPropertiesToRemove
                .map((propertyName) => {
                const property = Records.findValue(componentProperties || {}, (property) => property.name === propertyName);
                return property?.uid;
            })
                .filter((propertyUid) => propertyUid !== undefined);
            propertyRemovalMap[element.uid] = {
                type: "elements",
                propertyKeysToRemove: componentPropertyUidsToRemove,
            };
            const componentPropertiesToSet = component.componentPropertiesToAddOrEdit.reduce((acc, property) => {
                const existingProperty = Records.findValue(componentProperties || {}, (existingProperty) => existingProperty.name === property.name);
                if (existingProperty) {
                    const updatedProp = {
                        ...existingProperty,
                        value: property.value,
                        unit: property.unit || existingProperty.unit,
                    };
                    return {
                        ...acc,
                        [existingProperty.uid]: updatedProp,
                    };
                }
                else {
                    const uid = guid();
                    const newProp = {
                        uid: uid,
                        name: property.name,
                        value: property.value,
                        unit: property.unit ?? undefined,
                    };
                    return {
                        ...acc,
                        [uid]: newProp,
                    };
                }
            }, {});
            componentPropertiesUpdated.push({
                componentDesignator: component.componentDesignator,
                propertiesUpdated: [...component.componentPropertiesToAddOrEdit],
                propertiesRemoved: [...component.componentPropertiesToRemove],
            });
            propertyUpdateMap[element.uid] = {
                subjectType: "elements",
                propertyUpdates: componentPropertiesToSet,
            };
            touchedElementUids.push(element.uid);
        }
    });
    if (keys(propertyRemovalMap).length > 0) {
        handleRemoveSubjectProperties(document, propertyRemovalMap, actionContext.logger);
    }
    if (keys(propertyUpdateMap).length > 0) {
        handleSetSubjectProperties(document, actionContext.logger, propertyUpdateMap);
    }
    return {
        componentPropertiesUpdated,
        touchedElementUids,
    };
}
//# sourceMappingURL=applyComponentPropertiesAction.js.map